import BaseModel from "../default/base-model";
import {Client} from "./client";
import {Category} from "./category";
import {Project} from "./project";
import {SelectItem} from "./select-item";

export class PoMonitoring extends BaseModel {
    id: number;
    client: Client;
    origin: PoMonitoringOrigin;
    number: string;
    category: Category;
    projects: { id: number, project: Project }[];
    status: PoMonitoringStatus;
    completeness: number;
    url: string;
    purchase_date: string;
    supplier?: { id: number, name: string };
    po_total: number;
    purchase_request?: string;

    constructor() {
        super();
        this.id = 0;
        this.client = new Client();
        this.origin = PoMonitoringOrigin.NATIONAL;
        this.number = "";
        this.category = new Category();
        this.projects = [];
        this.status = PoMonitoringStatus.PENDING;
        this.completeness = 0;
        this.url = "";
        this.purchase_date = "";
        this.supplier = undefined;
        this.po_total = 0;
        this.purchase_request = undefined;
    }
}

export enum PoMonitoringOrigin {
    NATIONAL = "NATIONAL",
    IMPORTED = "IMPORTED"
}

export enum PoMonitoringStatus {
    PENDING = 1,
    CANCELED = 2,
    COMPLETED = 3,
    ADDED = 4
}


export const PoMonitoringStatusList: SelectItem[] = [
    {value: '0', label: "all"},
    {value: PoMonitoringStatus.ADDED, label: "added"},
    {value: PoMonitoringStatus.COMPLETED, label: "completed"},
    {value: PoMonitoringStatus.PENDING, label: "pending"},
    {value: PoMonitoringStatus.CANCELED, label: "canceled"}
];

export class PoMonitoringDashboard {
    completed_purchase_orders: number;
    new_purchase_orders: number;
    pending_purchase_orders: number;

    constructor() {
        this.completed_purchase_orders = 0;
        this.new_purchase_orders = 0;
        this.pending_purchase_orders = 0;
    }
}

export class ConfirmationPoMonitoringNre {
    id: number;
    number: string;
    purchase_date: string;
    purchase_request?: string;
    selected: boolean;
    supplier_name?: string;
    supplier: {
        id: number;
        name: string;
    }

    constructor() {
        this.id = 0;
        this.number = "";
        this.purchase_date = "";
        this.purchase_request = undefined;
        this.selected = false;
        this.supplier_name = undefined;
        this.supplier = {id: 0, name: ""};
    }
}
